import React, { useEffect, useState, useMemo } from "react";
import { Form, Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { BiCategory } from "react-icons/bi";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { Modal } from "react-bootstrap";
import Cookies from 'js-cookie';
import { decrpt } from '../../component/encryption';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SubCategory() {
  const [loader, setLoader] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState();
  const [Eshow, setEShow] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategoryPreview, setSubCategoryPreview] = useState({
    image: '',
    banner_image: ''
  });
  const [subCategory, setSubCategory] = useState([]);
  const [editSubCategory, setEditSubCategory] = useState();
  const [updateStatus, setUpdateStatus] = useState();
  const [statusShow, setStatusShow] = useState(false);
  const [dshow, setDShow] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [newSubCategory, setNewSubCategory] = useState({
    id: '',
    name: '',
    category_id: '',
    category_name: '',
    level: '2',
    image: '',
    banner_image: '',
    commission: '',
  });

  const [subCategorySelected, setSubCategorySelected] = useState({
    id: '',
    name: '',
    category_id: '',
    level: '2',
    image: '',
    banner_image: '',
    commission: '',
  });

  // Pagination & Search states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const handleOpen = (item) => {
    setNewSubCategory({
      id: '',
      name: '',
      category_id: '',
      category_name: '',
      level: '2',
      image: '',
      banner_image: '',
      commission: '',
    });
    setDisabled(true);
    setErrors();
    setShow(true);
    setSubCategoryPreview({
      image: '',
      banner_image: ''
    });
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleStatusClose = () => {
    setStatusShow(false);
  };

  const editCall = (item) => {
    setEditSubCategory(item);
    setNewSubCategory(item);
    setSubCategorySelected(item);
    setErrors();
    setEShow(true);
  };

  const handleCloseEdit = () => {
    setEShow(false);
  };

  const textHandler = (e) => {
    setDisabled(false);
    setNewSubCategory({ ...newSubCategory, name: e.target.value });
  };

  const subCategoryHandler = (e) => {
    setNewSubCategory({ ...newSubCategory, category_id: e.target.value });
    setDisabled(false);
  };

  function handlePreview(e) {
    if (e.target.files && e.target.files[0]) {
      setSubCategoryPreview({ ...subCategoryPreview, image: URL.createObjectURL(e.target.files[0]) });
      setNewSubCategory({ ...newSubCategory, image: e.target.files[0] });
    }
  }

  function handleBannerPreview(e) {
    if (e.target.files && e.target.files[0]) {
      setSubCategoryPreview({ ...subCategoryPreview, banner_image: URL.createObjectURL(e.target.files[0]) });
      setNewSubCategory({ ...newSubCategory, banner_image: e.target.files[0] });
    }
  }

  const handleStatus = (item) => {
    setStatusShow(true);
    setUpdateStatus(item);
  };

  // Get Parent 1st Level Category List for dropdown
  const getCategoryList = async () => {
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/list`, { type: 1 });
      if (response.data?.success && response.data?.data) {
        let list = response.data.data.list || [];
        const pagination = response.data.data.pagination;
        if (pagination && pagination.total_pages > 1 && list.length < pagination.total_data) {
          const pagePromises = [];
          for (let p = 2; p <= pagination.total_pages; p++) {
            pagePromises.push(axios.post(`admin/category/list?page=${p}`, { type: 1 }));
          }
          const extraResponses = await Promise.all(pagePromises);
          extraResponses.forEach((res) => {
            if (res.data?.success && res.data?.data?.list) {
              list = list.concat(res.data.data.list);
            }
          });
        }
        setCategory(list);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Get Sub Category List
  const getSubCategoryList = async () => {
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/list`, { type: 2 });
      if (response.data?.success && response.data?.data) {
        let list = response.data.data.list || [];
        const pagination = response.data.data.pagination;
        if (pagination && pagination.total_pages > 1 && list.length < pagination.total_data) {
          const pagePromises = [];
          for (let p = 2; p <= pagination.total_pages; p++) {
            pagePromises.push(axios.post(`admin/category/list?page=${p}`, { type: 2 }));
          }
          const extraResponses = await Promise.all(pagePromises);
          extraResponses.forEach((res) => {
            if (res.data?.success && res.data?.data?.list) {
              list = list.concat(res.data.data.list);
            }
          });
        }
        setSubCategory(list);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  // Filtered sub-categories by search
  const filteredSubCategories = useMemo(() => {
    if (!Array.isArray(subCategory)) return [];
    if (!searchText.trim()) return subCategory;
    const q = searchText.trim().toLowerCase();
    return subCategory.filter((c) => {
      const name = (c.name || "").toLowerCase();
      const catName = (c.category_name || "").toLowerCase();
      const id = String(c.id || "").toLowerCase();
      const commission = String(c.commission || "").toLowerCase();
      return name.includes(q) || catName.includes(q) || id.includes(q) || commission.includes(q);
    });
  }, [subCategory, searchText]);

  // Pagination logic
  const totalItems = filteredSubCategories.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  // Keep currentPage within valid range whenever totalPages or itemsPerPage changes
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedSubCategories = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredSubCategories.slice(startIndex, endIndex);
  }, [filteredSubCategories, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // Add Sub Category
  const addSubCategory = async () => {
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("level", 2);
      formData.append("name", newSubCategory.name);
      formData.append("category_id", newSubCategory.category_id);
      formData.append("image", newSubCategory.image);
      formData.append("banner_image", newSubCategory.banner_image);
      formData.append("commission", newSubCategory.commission);

      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/save`, formData);

      if (response.data.success) {
        handleClose();
        let newData = response.data.data;
        setSubCategory((prev) => (Array.isArray(prev) ? [newData, ...prev] : [newData]));
        toast.success("Sub Category Added", { hideProgressBar: true });
        setSubCategoryPreview({ image: '', banner_image: '' });
        setLoader(false);
      }
    } catch (err) {
      console.error('Error', err);
      setErrors(err.response?.data?.errors);
      setLoader(false);
      toast.error("Something went wrong", { hideProgressBar: true });
    }
  };

  const categoryStatus = async () => {
    setLoader(true);
    try {
      let newstatus = updateStatus.status == 1 ? 2 : 1;
      const data = {
        id: updateStatus.id,
        status: newstatus
      };
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      await axios.post(`admin/category/status`, data);

      setSubCategory((prev) => {
        if (!Array.isArray(prev)) return [];
        return prev.map((item) => (item.id === updateStatus.id ? { ...item, status: newstatus } : item));
      });
      setStatusShow(false);
      toast.success("Status Updated", { hideProgressBar: true });
      setLoader(false);
    } catch (error) {
      console.log(error, 'error');
      setLoader(false);
      toast.error("Failed to update status", { hideProgressBar: true });
    }
  };

  const updateSubCategory = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("id", newSubCategory.id);
    formData.append("level", 2);
    formData.append("category_id", newSubCategory.category_id);
    formData.append("name", editSubCategory.name);

    if (typeof newSubCategory.image !== 'string') {
      formData.append("image", newSubCategory.image);
    }

    if (typeof newSubCategory.banner_image !== 'string') {
      formData.append("banner_image", newSubCategory.banner_image);
    }

    formData.append("commission", editSubCategory.commission);

    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`admin/category/save`, formData);
      let newvar = response.data.data;

      setSubCategory((prev) => {
        if (!Array.isArray(prev)) return [newvar];
        return prev.map((item) => (item.id === newvar.id ? { ...item, ...newvar } : item));
      });
      toast.success("Sub Category Updated", { hideProgressBar: true });
      setLoader(false);
      setEShow(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setEShow(true);
      setErrors(error.response?.data?.errors);
      toast.error("Something went wrong", { hideProgressBar: true });
    }
  };

  const handleCloseDelete = () => {
    setDShow(false);
    setDeleteItem(null);
  };

  const handleDelete = (item) => {
    setDeleteItem(item);
    setDShow(true);
  };

  const confirmDeleteSubCategory = async () => {
    if (!deleteItem) return;
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/category/delete`, { id: deleteItem.id });
      if (response.data?.success) {
        setSubCategory((prev) => (Array.isArray(prev) ? prev.filter((c) => c.id !== deleteItem.id) : []));
        toast.success("Sub Category Deleted Successfully", { hideProgressBar: true });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete sub category", { hideProgressBar: true });
    } finally {
      setDShow(false);
      setDeleteItem(null);
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getSubCategoryList();
    getCategoryList();
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={'colored'}
          />
          {/* Sub Category List */}
          <div className="section">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h5>
                    <BiCategory className="me-1" />
                    All Sub Category
                  </h5>
                </div>
                <div className="card p-2 mt-3">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0">You have {totalItems} numbers of 2nd Level Category</h5>
                      <Button onClick={() => handleOpen()} className="badge btn-xs pt-1">
                        Add New Sub Category
                      </Button>
                    </div>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Sub Category, Category, ID..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Sub Category</th>
                          <th>Commission</th>
                          <th>Category</th>
                          <th>Image</th>
                          <th>Banner Image</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedSubCategories && paginatedSubCategories.length > 0 ? (
                          paginatedSubCategories.map((item, index) => {
                            return (
                              <tr key={item.id || index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                <td>{item && item.name}</td>
                                <td>{item && item.commission ? item.commission + '%' : '-'}</td>
                                <td>{item && item.category_name}</td>
                                <td>
                                  {item.image ? (
                                    <img src={item.image} style={{ width: 100, height: 100, objectFit: 'cover' }} alt={item.name} />
                                  ) : (
                                    <span className="text-muted">No Image</span>
                                  )}
                                </td>
                                <td>
                                  {item.banner_image ? (
                                    <img src={item.banner_image} style={{ width: 100, height: 100, objectFit: 'cover' }} alt={item.name} />
                                  ) : (
                                    <span className="text-muted">No Banner</span>
                                  )}
                                </td>
                                <td className="text-center">
                                  {item && item.status == 1 ? (
                                    <Badge bg="success">Enable</Badge>
                                  ) : (
                                    <Badge bg="danger">Disable</Badge>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button onClick={() => editCall(item)} className="btn btn-xs btn-primary text-white me-1">
                                    Edit
                                  </button>
                                  {item && item.status == 1 ? (
                                    <button type="button" onClick={() => handleStatus(item)} className="btn btn-xs btn-secondary text-white me-1">
                                      Make Disable
                                    </button>
                                  ) : (
                                    <button type="button" onClick={() => handleStatus(item)} className="btn btn-xs btn-success text-white me-1">
                                      Make Enable
                                    </button>
                                  )}
                                  <button type="button" onClick={() => handleDelete(item)} className="btn btn-xs btn-danger text-white">
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={8} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div
                        className="flex items-center justify-between mt-4 px-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                          padding: '0 0.5rem',
                          flexWrap: 'wrap',
                          gap: '0.75rem',
                        }}
                      >
                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            Show
                          </span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{
                              padding: '0.25rem 0.5rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              outline: 'none',
                              background: '#fff',
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            entries
                          </span>
                        </div>

                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === 1 ? 0.5 : 1,
                              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span
                            className="text-sm font-medium px-2 text-gray-700"
                            style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}
                          >
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === totalPages ? 0.5 : 1,
                              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                            }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to{' '}
                          {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Add Sub Category Modal */}
                  <Modal size="md" show={show} onHide={handleClose}>
                    <Modal.Header className="py-1" closeButton>
                      <Modal.Title>Add Sub Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Sub Category Image </Form.Label>
                          <Form.Control type="file" onChange={handlePreview} />
                          {errors && errors.image ? <p style={{ fontSize: 12, color: 'red' }}> {errors.image} </p> : ''}
                        </Form.Group>
                        <img
                          src={subCategoryPreview && subCategoryPreview.image ? subCategoryPreview.image : '/folder.png'}
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                          <Form.Label>Sub Category banner Image </Form.Label>
                          <Form.Control type="file" onChange={handleBannerPreview} />
                          {errors && errors.banner_image ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.banner_image} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                        <img
                          src={
                            subCategoryPreview && subCategoryPreview.banner_image !== ''
                              ? subCategoryPreview.banner_image
                              : '/folder.png'
                          }
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
                          <Form.Label>Category name</Form.Label>
                          <Form.Select aria-label="Select Category" onChange={subCategoryHandler} defaultValue="">
                            <option value="" disabled>----- Select From Below -----</option>
                            {category && category.map((item, index) => {
                              return <option key={index} value={item.id}>{item.name}</option>;
                            })}
                          </Form.Select>
                        </Form.Group>
                        {errors && errors.category_id ? (
                          <p style={{ fontSize: 12, color: 'red' }}> The category Field is required </p>
                        ) : (
                          ''
                        )}

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
                          <Form.Label>Sub Category Name</Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            placeholder="Enter Category Name"
                            onChange={(e) => textHandler(e)}
                            disabled={disabled}
                          />
                          {errors && errors.name ? <p style={{ fontSize: 12, color: 'red' }}> {errors.name} </p> : ''}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput5">
                          <Form.Label>Commission (%)*</Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="number"
                            placeholder="Enter Commission Percentage"
                            onChange={(e) => setNewSubCategory({ ...newSubCategory, commission: e.target.value })}
                          />
                          {errors && errors.commission ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.commission} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleClose()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button onClick={() => addSubCategory()} className="btn btn-primary btn-sm">
                        Save Changes
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Edit Sub Category Modal */}
                  <Modal size="md" show={Eshow} onHide={handleCloseEdit}>
                    <Modal.Header closeButton>
                      <Modal.Title>Edit Sub Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput6">
                          <Form.Label>Sub Category Image </Form.Label>
                          <Form.Control type="file" onChange={handlePreview} />
                          {errors && errors.image ? <p style={{ fontSize: 12, color: 'red' }}> {errors.image} </p> : ''}
                        </Form.Group>
                        <img
                          src={
                            subCategoryPreview && subCategoryPreview.image !== ''
                              ? subCategoryPreview.image
                              : subCategorySelected.image
                          }
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput7">
                          <Form.Label>Sub Category banner Image </Form.Label>
                          <Form.Control type="file" onChange={handleBannerPreview} />
                          {errors && errors.banner_image ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.banner_image} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                        <img
                          src={
                            subCategoryPreview && subCategoryPreview.banner_image !== ''
                              ? subCategoryPreview.banner_image
                              : subCategorySelected.banner_image
                          }
                          alt="preview"
                          style={{ width: 100, height: 100 }}
                        />

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput8">
                          <Form.Label>Select Category</Form.Label>
                          <Form.Select
                            value={editSubCategory && editSubCategory.category_id}
                            aria-label="Select Category"
                            onChange={(e) =>
                              setNewSubCategory({ ...newSubCategory, category_id: e.target.value })
                            }
                          >
                            <option value="">----- Select From Below -----</option>
                            {category && category.map((item, index) => {
                              return <option key={index} value={item.id}>{item.name}</option>;
                            })}
                          </Form.Select>
                          {errors && errors.category_id ? (
                            <p style={{ fontSize: 12, color: 'red' }}> Please select category </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput9">
                          <Form.Label>Sub Category Name</Form.Label>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="Enter Sub Category Name"
                            defaultValue={editSubCategory && editSubCategory.name}
                            onChange={(e) =>
                              setEditSubCategory({ ...editSubCategory, name: e.target.value })
                            }
                          />
                          {errors && errors.name ? <p style={{ fontSize: 12, color: 'red' }}> {errors.name} </p> : ''}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput10">
                          <Form.Label>Commission (%)</Form.Label>
                          <Form.Control
                            size="sm"
                            type="number"
                            placeholder="Enter Commission Percentage"
                            defaultValue={editSubCategory && editSubCategory.commission}
                            onChange={(e) =>
                              setEditSubCategory({ ...editSubCategory, commission: e.target.value })
                            }
                          />
                          {errors && errors.commission ? (
                            <p style={{ fontSize: 12, color: 'red' }}> {errors.commission} </p>
                          ) : (
                            ''
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleCloseEdit()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button onClick={() => updateSubCategory()} className="btn btn-primary btn-sm">
                        Save Changes
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Status Modal */}
                  <Modal size="md" show={statusShow} onHide={handleStatusClose} centered>
                    <Modal.Header className="py-1">
                      <Modal.Title className="h6">
                        Do you want to {updateStatus && updateStatus.status == 1 ? 'Disable' : 'Enable'} Sub category ? <br />
                        <span className="text-danger text-capitalize fw-bold">{updateStatus && updateStatus.name}</span>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleStatusClose()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={() => categoryStatus()}>
                        {updateStatus && updateStatus.status == 1 ? 'Make Disable' : 'Make Enable'}
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Delete Sub Category Modal */}
                  <Modal size="md" show={dshow} onHide={handleCloseDelete} centered>
                    <Modal.Header closeButton>
                      <Modal.Title className="h6 fw-bolder">Delete Sub Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete sub category <strong>{deleteItem?.name}</strong>?
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-end">
                      <button onClick={handleCloseDelete} className="btn btn-light btn-sm">
                        Cancel
                      </button>
                      <button onClick={confirmDeleteSubCategory} className="btn btn-danger btn-sm">
                        Delete
                      </button>
                    </Modal.Footer>
                  </Modal>

                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SubCategory;
